import { attribute, create, clickable, collection, fillable, isPresent, text, triggerable, visitable } from 'ember-cli-page-object';
const filterDropdown = scope => ({
  scope,
  open: clickable('button.hds-dropdown-toggle-button'),
  options: collection('.hds-form-checkbox', {
    name: attribute('data-test-name'),
    select: clickable(),
    isSelected: attribute('checked')
  }),
  async select(name) {
    const opt = this.options.findOneBy('name', name);
    await opt.select();
  }
});
export default create({
  visit: visitable('/public/discover'),
  userDropdown: {
    scope: '[data-test-user-menu]',
    toggle: clickable('[data-test-user-menu-toggle]'),
    email: text('[data-test-user-menu-email]'),
    isLoggedOut: isPresent('[data-test-link-sign-in]'),
    isLoggedIn: isPresent('[data-test-user-menu-email]')
  },
  filters: {
    scope: '.cut-filter-bar',
    searchInput: fillable('input.cut-filter-bar-search'),
    searchEnter: triggerable('keyup', 'input.cut-filter-bar-search', {
      eventProperties: {
        key: 'Enter'
      }
    }),
    async search(term) {
      await this.searchInput(term);
      await this.searchEnter();
    },
    providers: filterDropdown('.cut-filter-bar-filter-group .hds-dropdown:eq(0)'),
    architectures: filterDropdown('.cut-filter-bar-filter-group .hds-dropdown:eq(1)'),
    sort: {
      scope: '.sort-controls',
      open: clickable('button.hds-dropdown-toggle-button'),
      options: collection('.hds-dropdown-list-item button', {
        value: attribute('data-test-value'),
        select: clickable(),
        isSelected: isPresent('.hds-dropdown-list-item__checkmark .hds-icon')
      }),
      async select(value) {
        const opt = this.options.findOneBy('value', value);
        await opt.select();
      }
    }
  },
  boxes: collection('[data-test-results] tbody tr', {
    name: text('td:eq(0) a'),
    href: attribute('href', 'td:eq(0) a'),
    isExternal: isPresent('td:eq(0) [data-test-icon="external-link"]'),
    latestVersion: text('td:eq(1)'),
    downloads: text('td:eq(2)'),
    latestRelease: text('td:eq(3)'),
    providers: collection('td:eq(4) .hds-badge'),
    architectures: collection('td:eq(5) .hds-badge'),
    visit: clickable('td:eq(0) a')
  }),
  pagination: {
    scope: 'nav.hds-pagination-nav',
    next: clickable('.hds-pagination-nav__arrow--direction-next'),
    prev: clickable('.hds-pagination-nav__arrow--direction-prev'),
    hasNext: isPresent('.hds-pagination-nav__arrow--direction-next'),
    hasPrev: isPresent('.hds-pagination-nav__arrow--direction-prev')
  }
});